import type React from 'react'

import type { IconProps } from '../../types/props.ts'
import { ArrowPathCircleIcon } from '../arrow-path-circle-icon.tsx'
import { BigCheckIcon } from '../big-check-icon.tsx'
import { BigXIcon } from '../big-x-icon.tsx'
import { CelebrationIcon } from '../celebration-icon.tsx'
import { CircleIcon } from '../circle-icon.tsx'
import { DotIcon } from '../dot-icon.tsx'
import { EditIcon } from '../edit-icon.tsx'
import { ErrorIcon } from '../error-icon.tsx'
import { ExclamationIcon } from '../exclamation-icon.tsx'
import { InfoIcon } from '../info-icon.tsx'
import { LoadingDots } from '../loading-dots.tsx'
import { MaintenanceIcon } from '../maintenance-icon.tsx'
import { BarChart } from '../navigation/bar-chart.tsx'
import { Bell } from '../navigation/bell.tsx'
import { ColorWheel } from '../navigation/color-wheel.tsx'
import { Folder } from '../navigation/folder.tsx'
import { Organizations } from '../navigation/organizations.tsx'
import { Packages } from '../navigation/packages.tsx'
import { Projects } from '../navigation/projects.tsx'
import { Users } from '../navigation/users.tsx'
import { CtvIconDark } from '../partner-program-logos/dark/ctv-icon-dark.tsx'
import { LinkedInIconDark } from '../partner-program-logos/dark/linkedin-icon-dark.tsx'
import { MetaIconDark } from '../partner-program-logos/dark/meta-icon-dark.tsx'
import { QuickFrameIconDark } from '../partner-program-logos/dark/quickframe-icon-dark.tsx'
import { TikTokIconDark } from '../partner-program-logos/dark/tiktok-icon-dark.tsx'
import { CtvIcon } from '../partner-program-logos/light/ctv-icon.tsx'
import { LinkedInIcon } from '../partner-program-logos/light/linkedin-icon.tsx'
import { MetaIcon } from '../partner-program-logos/light/meta-icon.tsx'
import { QuickFrameIcon } from '../partner-program-logos/light/quickframe-icon.tsx'
import { TikTokIcon } from '../partner-program-logos/light/tiktok-icon.tsx'
import { ProductionCameraIcon } from '../production-camera-icon.tsx'
import { RocketUpIcon } from '../rocket-up-icon.tsx'
import { SuccessIcon } from '../success-icon.tsx'
import { TanstackQueryIcon } from '../vendor-logos/tanstack-query-icon.tsx'
import { VideoIcon } from '../video-icon.tsx'
import { WarningIcon } from '../warning-icon.tsx'
import type { SvgIconName } from './names.ts'

export const svgIconMap: Record<SvgIconName, React.ComponentType<IconProps>> = {
  'nav-bar-chart': BarChart,
  'nav-bell': Bell,
  'nav-color-wheel': ColorWheel,
  'nav-folder': Folder,
  'nav-packages': Packages,
  'nav-projects': Projects,
  'nav-users': Users,
  'nav-organizations': Organizations,
  ArrowPathCircleIcon: ArrowPathCircleIcon,
  BigCheckIcon,
  BigXIcon,
  CelebrationIcon,
  CircleIcon,
  CtvIcon,
  CtvIconDark,
  DotIcon,
  EditIcon,
  ErrorIcon,
  ExclamationIcon,
  InfoIcon,
  LinkedInIcon,
  LinkedInIconDark,
  LoadingDots,
  MaintenanceIcon,
  MetaIcon,
  MetaIconDark,
  ProductionCameraIcon,
  QuickFrameIcon,
  QuickFrameIconDark,
  RocketUpIcon,
  SuccessIcon,
  TanstackQueryIcon,
  TikTokIcon,
  TikTokIconDark,
  VideoIcon,
  WarningIcon,
}
